import { Route } from 'react-router-dom';
import { parrainageViewSchema } from './parrainageView';
import { parrainageSchema } from '@app/Modules/data/Parrainage/parrainage';
import Main from '@app/main/tables/Main';

/**
 * Routes configurées pour le module ParrainageView
 */
const ParrainageViewRoutes = [
    // Route de liste (principale)
    <Route
        key="parrainage-view"
        path="parrainages"
        element={
            <Main
                key="parrainage-view-main"
                pageConfig={parrainageViewSchema}
            />
        }
    />,

    <Route
        key="parrainage-view-main-data-parrainages"
        path="parrainages/data/parrainages"
        element={<Main pageConfig={parrainageSchema} />}
    />,
];

export default ParrainageViewRoutes;
